export default "__VITE_ASSET__BbKCRwhE__"